import { HeroldMap } from "./modulesMap/HeroldMap";

$(function () {
    var resultMap = new HeroldMap()
        .setKey(mapboxGLKey)
        .setType('iframe')
        .setControls($mapGL.data())
        .setZoom(mapConf.zoom)
        .setStyle(mapConf.mapType)
        .setPoiconfig(poiconfig)
        .setFeatures(mapConf.features)
        .build();
});